import React from 'react';
import useAzureBlobImage from '../../hooks/useAzureBlobImages';

type Props = {
  productCode: string;
  itemName?: string;
};

export const InsufficientItem: React.FC<Props> = ({
  productCode,
  itemName,
}) => {
  const { image, loading, error } = useAzureBlobImage(productCode);

  const formatItemName = (name?: string) => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  return (
    <li
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '8px',
      }}
    >
      <div>
        {loading ? (
          <div
            className="skeleton skeleton--image"
            aria-label="Cargando imagen..."
          />
        ) : (
          <img
            src={image?.url}
            alt={`Imagen de ${productCode}`}
            width={48}
            height={48}
            style={{ objectFit: 'cover', borderRadius: 4 }}
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = '/placeholder.jpg';
            }}
          />
        )}
      </div>
      <div>
        <div className="code">
          {productCode} - {formatItemName(itemName)}
        </div>

        {error && (
          <div className="img-error" role="status">
            img: {error}
          </div>
        )}
      </div>
    </li>
  );
};
